<template>
    <div class="all">
        <!--详情-->
        <template v-if="status==='info'">
            <!--单位详情-->
            <div class="panel">
                <div class="head">
                    <span class="title">个人信息</span>
                    <span class="edit" v-if="userAuth.editUser === true">
                        <a @click="jumpEdit">
                            <Icon type="edit"></Icon>
                            编辑
                        </a>
                    </span>
                </div>
                <!--头像-->
                <div class="baseinfo">
                    <label class="item-label">
                        <span class="label-title">
                            姓名：
                        </span>
                        <span>
                            {{userInfo.username}}
                        </span>
                    </label>
                    <label class="item-label">
                        <span class="label-title">
                            用户编号：
                        </span>
                        <span>
                            {{userInfo.uid}}
                        </span>
                    </label>
                    <label class="item-label">
                        <span class="label-title">
                            部门：
                        </span>
                        <span>
                            {{userInfo.company_group_name}}
                        </span>
                    </label>
                    <label class="item-label">
                        <span class="label-title">
                            职位：
                        </span>
                        <span>
                            {{userInfo.position}}
                        </span>
                    </label>
                    <label class="item-label">
                        <span class="label-title">
                            手机号：
                        </span>
                        <span>
                            {{userInfo.tkphone}}
                        </span>
                    </label>
                    <label class="item-label">
                        <span class="label-title">
                            QQ号：
                        </span>
                        <span>
                            {{userInfo.bqq}}
                        </span>
                    </label>
                    <label class="item-label">
                        <span class="label-title">
                            座机：
                        </span>
                        <span>
                            {{userInfo.phone_one}}-{{userInfo.phone_two}}-{{userInfo.phone_three}}
                        </span>
                    </label>
                    <label class="item-label">
                        <span class="label-title">
                            邮箱：
                        </span>
                        <span>
                            {{userInfo.email}}
                        </span>
                    </label>
                    <label class="item-label">
                        <span class="label-title">
                            地区：
                        </span>
                        <span>
                            {{userInfo.district}}
                        </span>
                    </label>
                    <label class="item-label" style="white-space: normal">
                        <span class="label-title">简介：
                        </span>
                        <span v-html="fixBr(userInfo.intro)">
                            <!--{{userInfo.intro}}-->
                        </span>
                    </label>

                    <div class="head">
                        <span class="label-title">
                            头像：
                        </span>
                        <div class="logo">
                            <img :src="userInfo.logo" :onerror="'this.src=\''+ require('@/assets/images/default-head-pic.jpg')+'\'' "  />
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <!--编辑-->
        <template v-if="status==='edit'">
            <div class="panel">
                <div class="head">
                    <span class="title">个人信息</span>
                </div>
                <!--编辑-->
                <div class="edit-user">
                    <Row>
                        <Col span="10">
                            <Form ref="editUser" :model="userInfo" :rules="userFormRule" :inline="true" >
                                <Row>
                                    <Col span="10">
                                        <FormItem label="姓名" prop="username" style="width: 100%;">
                                            <Input v-model="userInfo.username" placeholder="请填写姓名"></Input>
                                        </FormItem>
                                    </Col>
                                    <Col span="10" offset="1">
                                        <FormItem label="职位" prop="position" style="width: 100%">
                                            <Input v-model="userInfo.position" placeholder="请填写职位"></Input>
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span="10">
                                        <FormItem label="手机号" prop="tkphone" style="width: 100%">
                                            <Input v-model="userInfo.tkphone" placeholder="请填写手机号"></Input>
                                        </FormItem>
                                    </Col>
                                    <Col span="10" offset="1">
                                        <FormItem label="QQ号" prop="qq" style="width: 100%">
                                            <Input v-model="userInfo.bqq" placeholder="请填写QQ号"></Input>
                                        </FormItem>
                                    </Col>

                                </Row>
                                <Row>
                                    <Col span="10">
                                        <FormItem label="邮箱" prop="email" style="width: 100%">
                                            <Input v-model="userInfo.email" placeholder="请填写邮箱地址"></Input>
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span="24">
                                        <FormItem label="座机" prop="phone" style="width: 100%;">
                                            <div class="phone-list phone-input-box">
                                                <input type="text" class="ivu-input"  v-model="userInfo.phone_one" placeholder="请填写区号" style="width:calc( 33.33333% - 18px );border-radius: 0"/>
                                                <input type="text" class="ivu-input line"  value=" - " disabled />
                                                <input type="text" class="ivu-input"  v-model="userInfo.phone_two" placeholder="请填写座机号" style="width:calc( 33.33333% - 18px );border-radius: 0"/>
                                                <input type="text" class="ivu-input line"  value=" - " disabled />
                                                <input type="text" class="ivu-input"  v-model="userInfo.phone_three" placeholder="请填写分机号" style="width:calc( 34.2% - 20px );border-top-left-radius: 0;border-bottom-left-radius: 0"/>
                                            </div>
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span="24">
                                        <address-select @refreshData="refreshDirect" ref="addsel" :title="'所在地区'" :input-width="'33.33%'" :all="false" :level="3" :default-options="[userInfo.district_1st,userInfo.district_2nd,userInfo.district_3rd]" :rules="['district_1st','district_2nd','district_3rd']"></address-select>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span="24">
                                        <FormItem label="个人简介" style="width: 100%">
                                            <Input v-model="userInfo.intro" type="textarea" placeholder="请填写个人简介"></Input>
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Form>
                            <div class="edit-btn">
                                <Button type="primary" @click="saveBaseInfo" :loading="loading1">保存</Button>
                            </div>
                        </Col>
                        <Col span="10" offset="2">
                            <div class="logo">
                                <label>头像（请上传清晰的职业照)</label>
                                <img :src="userInfo.logo" alt="头像" :onerror="errpic" />
                                <Button @click="upload">上传</Button>
                            </div>
                        </Col>
                    </Row>
                    <Col span="24">
                        <Cropper ref="cropper" @returnFile="setLogo"></Cropper>
                    </Col>
                </div>
            </div>
        </template>

        <!--更换部门-->
        <template v-if="userAuth.editUser === true">
            <edit-user-group ref="editGroup" :uid="uid" :username="userInfo.username" :group-id="userInfo.company_group_id" @refresh="refresh" ></edit-user-group>
        </template>

        <!--基础权限-->
        <template v-if="userAuth.editAuth === true">
            <user-base-auth :uid="uid" @refresh="refresh"></user-base-auth>
        </template>
    </div>
</template>

<script>
    import AddressSelect from "@/components/addressSelect/AddressSelect.vue";
    import EditUserGroup from "./business/EditUserGroup";
    import UserBaseAuth from "./business/UserBaseAuth";
    import userRule from "@/validateRule/company/userBaseInfo"
    import baseAuthEnum from "@/staticData/baseAuthEnum";
    import $api from "@/service/index";
    import utils from "@/utils";
    import Cropper from "@/components/imgCropper/Cropper";

    export default {
        components:{
            AddressSelect,
            EditUserGroup,
            UserBaseAuth,
            Cropper
        },
        data(){
            return {
                //form验证规则
                userFormRule:userRule,
                //是否处于编辑状态 info-查看，edit-编辑
                status : "info",
                //用户id
                uid : 0,
                //用户信息
                userInfo : {},
                //用户权限
                userAuth : {
                    editUser : true,
                    editAuth : true,
                },
                loading1 : false,   //编辑基本信息loading
                errpic: 'this.src="'+ require("@/assets/images/default-head-pic.jpg") + '"',
            }
        },
        created(){
            this.uid = this.$route.params.id;
            this.getUserAuth();
            this.getUserInfo();
        },
        methods : {
            //刷新
            refresh(){
                this.uid = this.$route.params.id;
                this.getUserAuth();
                this.getUserInfo();
            },
            //获取用户权限
            getUserAuth(){
                let _self = this;
                this.userAuth = Object.assign({
                    editUser : false,
                    editAuth : false,
                },
                {
                    editUser : utils.judgeAuth([baseAuthEnum.EDIT_COMPANY_USER_INFO],1),
                    editAuth : utils.judgeAuth([baseAuthEnum.AUTH_SETTING],1),
                })
            },
            //获取用户基本信息
            getUserInfo(){
                if(this.uid === 0 || !this.uid || this.uid === ""){
                    utils.notice("获取用户uid失败，请刷新重试!","error");
                    return false
                }
                let _self = this;
                $api.getUserBaseInfo(this.uid).then(data=>{
                    _self.userInfo = data;
                    //手动设置下所属部门备选项，解决无初始值问题
                    _self.$refs.editGroup.setGid(data.company_group_id);
                });
            },
            //编辑按钮点击
            jumpEdit(){
                this.status = "edit";
            },
            //刷新用户所属地区
            refreshDirect(){
                if(this.$refs.addsel){
                    this.userInfo.district_1st = this.$refs.addsel.getSelect()[0];
                    this.userInfo.district_2nd = this.$refs.addsel.getSelect()[1];
                    this.userInfo.district_3rd = this.$refs.addsel.getSelect()[2];
                }
            },
            //保存基本数据
            saveBaseInfo(){
                let _self = this;
                _self.userInfo.phone =_self.userInfo.phone_one + '-' + _self.userInfo.phone_two + '-' + _self.userInfo.phone_three;
                _self.userFormRule.phone = [
                    {
                        validator: (rule, value, callback) => {
                            let patt = /^(0[0-9]{2,3})+\-([2-9][0-9]{6,7})+(\-[0-9]+)?$/;
                            if(!patt.test(_self.userInfo.phone) && (_self.userInfo.phone_one || _self.userInfo.phone_two || _self.userInfo.phone_three)){
                                callback(new Error("请填写正确的座机号"));
                            }
                            callback();
                        },
                        trigger: 'change,blur'
                    }
                ];
                this.$refs.editUser.validate((valid) => {
                    if (valid) {
                        _self.doSaveBaseInfo();
                    } else {
                        this.$Message.error("您还有信息未填写或未验证通过");
                    }
                })
            },
            //执行保存基本数据
            doSaveBaseInfo(){
                this.loading1 = true;
                let _self = this;
                let postData = {
                    'username'      :   this.userInfo.username,
                    'position'      :   this.userInfo.position,
                    'tkphone'       :   this.userInfo.tkphone,
                    'phone_one'     :   this.userInfo.phone_one ? this.userInfo.phone_one : "",
                    'phone_two'     :   this.userInfo.phone_two ? this.userInfo.phone_two : "",
                    'phone_three'   :   this.userInfo.phone_three ? this.userInfo.phone_three : "",
                    'email'         :   this.userInfo.email,
                    'district_1st'  :   this.userInfo.district_1st,
                    'district_2nd'  :   this.userInfo.district_2nd,
                    'district_3rd'  :   this.userInfo.district_3rd,
                    'intro'         :   this.userInfo.intro,
                    'logo'          :   this.userInfo.logo,
                    'shortLogo'     :   this.userInfo.shortLogo,
                    'bqq'     :   this.userInfo.bqq,
                };
                $api.setUserBaseInfo(_self.uid,postData).then(data=>{
                    _self.loading1 = false;
                    // utils.notice('保存成功',"success");
                    utils.message({title: '保存成功'}, 'success');
                    _self.refresh();
                    _self.status = "info";
                });
            },
            /**
             * 空格换行符转html格式
             * @param {string} str 待装换的字符串
             * @returns {string}
             */
            fixBr(str = ""){
                return utils.changeWarpToBr(str);
            },
            //选择头像
            upload(){
                this.$refs.cropper.openUploadModel();
            },
            /**
             * 设置头像
             * @param {object} file 头像内容
             */
            setLogo(file){
                this.userInfo.logo = file.domain + file.logo;
                this.userInfo.shortLogo = file.logo;
            },
        },
    }
</script>

<style scoped>
 @import "./detail.less";
</style>
<style lang="less">
.edit-user{
    .ivu-form-item-label{
        padding-top: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/company/member/Detail.vue